(function () {
  window.onMhlTurnstileLoad = function () {
    document.dispatchEvent(new CustomEvent('mhl:turnstile-ready'));
  };

  function initializeBackInStock() {
    var modal = document.getElementById('BackInStockModal');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    var endpoint = modal.dataset.backInStockEndpoint;
    var form = modal.querySelector('[data-back-in-stock-form]');
    var productTitleElement = modal.querySelector('[data-back-in-stock-product-title]');
    var messageElement = modal.querySelector('[data-back-in-stock-message]');
    var submitButton = form.querySelector('.back-in-stock-modal__submit');
    var submitLabel = submitButton.querySelector('.back-in-stock-modal__submit-label');
    var currentProduct = null;
    var lastTrigger = null;
    var modalGeneration = 0;
    var subscriptionController = null;
    var suppressNextEscapeKeyup = false;
    var turnstileWidgetId = null;

    function renderTurnstile() {
      var container = form.querySelector('.back-in-stock-modal__turnstile');
      if (!window.turnstile || !container || turnstileWidgetId !== null) return;
      turnstileWidgetId = window.turnstile.render(container, {
        sitekey: container.dataset.sitekey,
        action: container.dataset.action,
        'response-field-name': 'turnstile-token'
      });
    }

    function resetTurnstile() {
      if (!window.turnstile) return;
      if (turnstileWidgetId === null) {
        renderTurnstile();
        return;
      }
      window.turnstile.reset(turnstileWidgetId);
    }

    document.addEventListener('mhl:turnstile-ready', renderTurnstile);
    renderTurnstile();

    function buildVariantUrl(productUrl, variantId) {
      try {
        var url = new URL(productUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        return url.toString();
      } catch (error) {
        return productUrl;
      }
    }

    function buildAbsoluteUrl(url) {
      if (!url) return '';
      try {
        return new URL(url, window.location.origin).toString();
      } catch (error) {
        return '';
      }
    }

    function openModal(trigger) {
      modalGeneration += 1;
      if (subscriptionController) subscriptionController.abort();
      subscriptionController = null;
      currentProduct = {
        productId: trigger.dataset.productId || '',
        productTitle: trigger.dataset.productTitle || '',
        variantId: trigger.dataset.variantId || '',
        variantTitle: trigger.dataset.variantTitle || '',
        productUrl: buildVariantUrl(
          trigger.dataset.productUrl || window.location.href.split('?')[0],
          trigger.dataset.variantId || ''
        ),
        productImageUrl: buildAbsoluteUrl(trigger.dataset.productImageUrl || '')
      };
      lastTrigger = trigger;

      var detail = currentProduct.variantTitle && currentProduct.variantTitle !== 'Default Title'
        ? currentProduct.productTitle + '（' + currentProduct.variantTitle + '）'
        : currentProduct.productTitle;
      productTitleElement.textContent = detail ? '商品名：' + detail : '';
      messageElement.hidden = true;
      messageElement.removeAttribute('data-state');
      submitButton.disabled = false;
      submitLabel.textContent = '登録する';
      modal.classList.add('back-in-stock-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      resetTurnstile();

      var firstInput = form.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
      var initialFocus = firstInput || modal.querySelector('.back-in-stock-modal__close');
      if (typeof trapFocus === 'function') {
        trapFocus(modal, initialFocus);
      } else {
        initialFocus.focus();
      }
    }

    function closeModal() {
      if (!modal.classList.contains('back-in-stock-modal--open')) return;
      var trigger = lastTrigger;
      modalGeneration += 1;
      if (subscriptionController) subscriptionController.abort();
      subscriptionController = null;
      modal.classList.remove('back-in-stock-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resetTurnstile();
      form.reset();
      currentProduct = null;
      lastTrigger = null;
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      if (trigger && document.contains(trigger)) {
        var underlyingModal = trigger.closest('modal-dialog[open], quick-add-modal[open]');
        if (underlyingModal && typeof trapFocus === 'function') {
          trapFocus(underlyingModal, trigger);
        } else {
          trigger.focus();
        }
      }
    }

    function showMessage(message, state) {
      messageElement.textContent = message;
      messageElement.dataset.state = state;
      messageElement.hidden = false;
    }

    function findActions(productInfo) {
      return productInfo && productInfo.querySelector('[data-back-in-stock-actions]');
    }

    function setUnavailableState(productInfo) {
      var actions = findActions(productInfo);
      if (!actions) return;
      actions.hidden = true;
      var purchaseButton = productInfo.querySelector(
        '#ProductSubmitButton-' + CSS.escape(String(productInfo.dataset.section || ''))
      );
      if (purchaseButton) purchaseButton.hidden = false;
    }

    function updateVariantState(event) {
      var eventData = event && event.data;
      if (!eventData || !eventData.sectionId) return;

      var productInfo = eventData.productInfo;
      if (!productInfo || !productInfo.matches || !productInfo.matches('product-info')) return;
      if (!document.contains(productInfo)) return;
      var actions = findActions(productInfo);
      if (!actions) return;
      var trigger = actions.querySelector('[data-back-in-stock-trigger]');
      var renderedSectionId = String(productInfo.dataset.section || eventData.sectionId);
      var purchaseButton = productInfo.querySelector('#ProductSubmitButton-' + CSS.escape(renderedSectionId));
      var responseButton = eventData.html && eventData.html.getElementById(
        'ProductSubmitButton-' + eventData.sectionId
      );
      var soldOut = responseButton
        ? responseButton.hasAttribute('disabled')
        : !eventData.variant || eventData.variant.available === false;

      actions.hidden = !soldOut;
      if (purchaseButton) purchaseButton.hidden = soldOut;
      if (!trigger || !eventData.variant) return;

      trigger.dataset.variantId = String(eventData.variant.id || '');
      trigger.dataset.variantTitle = eventData.variant.title || '';
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-back-in-stock-trigger]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }
      if (event.target.closest('.back-in-stock-modal__close') || event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !modal.classList.contains('back-in-stock-modal--open')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextEscapeKeyup = true;
      closeModal();
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' || !suppressNextEscapeKeyup) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextEscapeKeyup = false;
    }, true);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!currentProduct || !currentProduct.variantId) return;

      var emailInput = form.querySelector('#BackInStockEmail');
      var turnstileInput = form.querySelector('input[name="turnstile-token"]');
      var email = emailInput ? emailInput.value.trim() : modal.dataset.customerEmail;
      if (!email || (emailInput && !emailInput.checkValidity())) {
        showMessage('メールアドレスを正しく入力してください。', 'error');
        return;
      }
      if (!turnstileInput || !turnstileInput.value) {
        showMessage('人間確認が完了していません。少し待ってから再度お試しください。', 'error');
        return;
      }

      submitButton.disabled = true;
      submitLabel.textContent = '登録中...';
      var requestGeneration = modalGeneration;
      var requestVariantId = currentProduct.variantId;
      var requestController = new AbortController();
      if (subscriptionController) subscriptionController.abort();
      subscriptionController = requestController;
      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          signal: requestController.signal,
          body: JSON.stringify({
            email: email,
            product_id: currentProduct.productId,
            variant_id: currentProduct.variantId,
            product_title: currentProduct.productTitle,
            variant_title: currentProduct.variantTitle,
            product_url: currentProduct.productUrl,
            product_image_url: currentProduct.productImageUrl,
            locale: document.documentElement.lang || 'ja',
            consent_at: new Date().toISOString(),
            website: form.querySelector('input[name="website"]').value,
            turnstile_token: turnstileInput.value
          })
        });
        var data = await response.json().catch(function () { return {}; });
        if (
          requestGeneration !== modalGeneration ||
          !currentProduct ||
          currentProduct.variantId !== requestVariantId
        ) return;
        if (!response.ok || !data.ok) throw new Error(data.error || 'request_failed');

        showMessage(
          data.already_registered
            ? 'この商品はすでに入荷通知へ登録されています。'
            : '入荷通知を登録しました。',
          'success'
        );
        submitLabel.textContent = '登録済み';
      } catch (error) {
        if (
          error.name === 'AbortError' ||
          requestGeneration !== modalGeneration ||
          !currentProduct ||
          currentProduct.variantId !== requestVariantId
        ) return;
        showMessage('登録に失敗しました。時間をおいて再度お試しください。', 'error');
        submitButton.disabled = false;
        submitLabel.textContent = '登録する';
        resetTurnstile();
      } finally {
        if (subscriptionController === requestController) subscriptionController = null;
      }
    });

    function subscribeToVariantEvents() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      if (PUB_SUB_EVENTS.optionValueSelectionChange) {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
          var source = event && event.data && event.data.event && event.data.event.target;
          var productInfo = source && source.closest('product-info');
          if (productInfo) {
            setUnavailableState(productInfo);
          }
        });
      }
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, updateVariantState);
    }

    subscribeToVariantEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBackInStock, { once: true });
  } else {
    initializeBackInStock();
  }
})();
